import React from "react";
import Fallback from "../../components/Fallback";

const History = React.lazy(() => import("./History"));
export const HistoryScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <History {...props} />
  </React.Suspense>
);
